"use strict";
exports.__esModule = true;
exports.UnsupportedContentTypeError = void 0;
var tslib_1 = require("tslib");
var ErrorWithMessage_1 = require("./ErrorWithMessage");
/**
 * Unsupported content type error
 */
var UnsupportedContentTypeError = /** @class */ (function (_super) {
    tslib_1.__extends(UnsupportedContentTypeError, _super);
    function UnsupportedContentTypeError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get transportable http error
     *
     * @return {number}
     */
    UnsupportedContentTypeError.getTransportableHTTPError = function () {
        return 415;
    };
    /**
     * Unsupported content type
     *
     * @return {InvalidFormatError}
     */
    UnsupportedContentTypeError.createUnsupportedContentTypeException = function () {
        return new UnsupportedContentTypeError("This content type is not accepted. Please use application/json");
    };
    return UnsupportedContentTypeError;
}(ErrorWithMessage_1.ErrorWithMessage));
exports.UnsupportedContentTypeError = UnsupportedContentTypeError;
